import { apolloClient } from "@/plugins/vue-apollo.js";

const createPromotinCharges = (_variables) => {
  // , limit, skip
  let responseFromApi;
  let variables = _variables;
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/settings/api/mutations/fee/create_promotion_charges.graphql"),
      variables: variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/settings/api/queries/fee/get_promotion_charges_query.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            }
          }
        };
        let allPromotionCharges = store.readQuery(query);
        allPromotionCharges.getAllPromotionCharges.promotionCharges.unshift(data.createPromotinCharges); //push to top
        store.writeQuery({
          ...query,
            data: allPromotionCharges,
        });
      }
    })
    .catch(error => {
      return error;
    });
  return responseFromApi;
};
export { createPromotinCharges };
